<template>
    <b-container fluid class="d-flex flex-column h-100 w-100 bg-white" :style="generateVariantStyle(Variant)">
        <!-- Boutons du haut -->
        <b-row class="w-100 p-0 m-0 ">
            <b-col class="p-0 m-0">
                <b-container fluid class="h-100 d-flex justify-content-end mt-2">
                    <b-row>
                        <b-col class="p-0 m-0">
                            <portal-target name="PortalGraphTypeList" v-if="context?.ShowConfigButtons"/>
                        </b-col>
                        <b-col v-if="!FSButtonPortalName" class="m-0 px-1"
                               :disabled="messages && messages.length > 0">
                            <hsc-menu-style-custom v-if="results && (('menus') in results)">
                                <hsc-menu-button-menu ref="axisContextMenu" class="menu w-100" :menuZIndex="3"
                                                      :Index="0">
                                    <b-button v-b-tooltip.hover :title="$t('AxisSettings')"
                                              variant="outline-black" class="p-1 border-0 btn-circle-small m-0">
                                        <!--:disabled="messages && messages.length > 0"-->
                                        <b-icon icon="gear"/>
                                    </b-button>
                                    <template slot="contextmenu">
                                        <template v-for="(menu, index) in results.menus">
                                            <template
                                                v-if="menu.label != undefined && (menu.group == undefined || menu.group.length === 0)
                                                        && menu.transform === undefined">
                                                <div class="ml-1 mr-1 mt-1 mb-1 text-gray-dark"
                                                     style="text-transform: uppercase; white-space: nowrap;">
                                                    {{ menu.label }}
                                                </div>
                                            </template>
                                            <template v-else>
                                                <chart-menu :Menu="menu" @CloseMenuEvent="closeMenu"
                                                            @TransformMenuEvent="transformMenu" :Results="results"
                                                            :Configs="configs"
                                                />
                                            </template>
                                        </template>
                                    </template>
                                </hsc-menu-button-menu>
                            </hsc-menu-style-custom>
                        </b-col>
                        <!-- Bouton Fullscreen si pas dans un widget -->
                        <b-col v-if="!FSButtonPortalName" class="m-0 p-0 pl-1 border-left">
                            <b-button @click="fullscreen = true" v-b-tooltip.hover :title="$t('FullscreenMode')"
                                      :disabled="messages && messages.length > 0"
                                      variant="outline-black" class="p-1 border-0 btn-circle-small m-0">
                                <b-icon icon="fullscreen"/>
                            </b-button>
                        </b-col>
                    </b-row>
                </b-container>
            </b-col>
        </b-row>

        <!-- Rendu du Apache EChart -->
        <b-row class="h-100"
               v-if="Loading || (results && (!('errors' in results) || results.errors === undefined || !Array.isArray(results.errors) || results.errors.length == 0))">
            <b-skeleton-wrapper :loading="Loading" class="row w-100 p-0 m-0">
                <!-- Mise en forme du Apache Echart d'attente pendant le chargement des données -->
                <template #loading>
                    <b-col align-self="center">
                        <div class="b-skeleton w-100 b-skeleton-icon b-skeleton-animate-fade bg-transparent text-gray-middle-dark"
                             align-v="center">
                            <font-awesome-icon icon="chart-line" size="6x" class="w-100"/>
                        </div>
                    </b-col>
                </template>
                <template
                    v-if="results && ('errors' in results) && results.errors && Array.isArray(results.errors) && results.errors.length === 0">
                    <portal :to="'render' + FSButtonPortalName"
                            :disabled="!fullscreen"
                            :id="$id('PortalChart')" class="w-100 h-100">
                        <b-overlay :show="messages && messages.length > 0" class="w-100 h-100" variant="transparent"
                                   blur="2px" style="z-index: 0;">
                            <template #overlay>
                                <div class="text-center">
                                    <b-badge variant="warning-light" class="text-warning-dark p-2"
                                             v-for="message in messages" :key="message">
                                        {{ message }}
                                    </b-badge>
                                </div>
                            </template>

                            <!-- Rendu du Apache EChart avec les données -->
                            <v-chart ref="chart" @finished="chartFinished" @datazoom="chartDatazoom" @click="chartClick"
                                     :option="results.option" autoresize :theme="results.graphTheme"
                                     :init-options="init_options" class="w-100 h-100"/>

                        </b-overlay>
                    </portal>
                </template>
            </b-skeleton-wrapper>
        </b-row>

        <!-- Affichage des messages d'erreur -->
        <b-row class="h-100 flex-grow-1 p-0 px-3"
               v-if="!Loading && results && ('errors' in results) && results.errors && Array.isArray(results.errors) && results.errors.length > 0"
               align-v="center">
            <b-col class="h-100 w-100 p-0" v-for="error in results.errors" :key="error.id" align-self="center">
                <b-alert :variant="error.id != 100 ? 'warning': Variant" show class="bold p-1" pill>
                    <font-awesome-icon icon="chart-line" class="pr-2 fa-2xl"/>
                    <b-icon icon="exclamation-triangle-fill" v-if="error.id != 100" font-scale="2" class="ml-3"></b-icon>
                    {{ error.message }}
                    <b-icon icon="exclamation-triangle-fill" v-if="error.id != 100" font-scale="2"></b-icon>
                </b-alert>
            </b-col>
        </b-row>

        <!-- Fenêtre modale pour le mode fullscreen -->
        <b-modal :title="Title" v-model="fullscreen" centered hide-footer title-class="text-center w-100"
                 header-class="p-0" dialog-class="fullscreen-modal" content-class="fullscreen-modal"
                 @close="fullscreen = false" no-close-on-backdrop no-close-on-esc>
            <!-- <b-row>Mode plein écran !  {{ FSButtonPortalName }}</b-row> -->
            <portal-target :name="'render' + FSButtonPortalName" class="h-100 w-100 p-0"
                           :id="'containerModal_' + this.WidgetId"/>
        </b-modal>

        <!-- Portal pour bouton de plein écran -->
        <portal v-if="FSButtonPortalName" :to="FSButtonPortalName">
            <b-col class="p-0">
                <b-icon @click="fullscreen = true" v-b-tooltip.hover :title="$t('FullscreenMode')" icon="fullscreen" role="button"/>
            </b-col>
        </portal>

        <component :is="'chart-work-' + (configs?.Feature ?? 'Evolution')"
                   :Result.sync="results" :Configs.sync="configs" :Messages.sync="messages"
                   v-if="configs && (('Feature') in configs) && configs.Feature"/>

        <!-- Pour l'affichage des évènements -->
        <b-modal :id="$id('chartEventModal')" :visible="eventModalVisible" scrollable centered no-close-on-backdrop
                 size="lg">
            <template #modal-header="{ close }">
                <b-row class="w-100 p-0 m-0 h-100 " align-v="center">
                    <b-col class="text-left">
                        <h5>{{ $t('EventList') }} : {{ eventsStartDate }}</h5>
                    </b-col>
                    <b-col class=" pr-0 p-1 pl-4 text-right">
                        <b-icon role="button" icon="x-lg" font-scale="1.5" @click="close(); eventModalVisible = false;"
                                v-b-tooltip.hover title="Fermer" />
                    </b-col>
                </b-row>
            </template>

            <!-- Affichage dans le tableau des évènements -->
            <b-row cols="1" class="m-1 p-0">
                <b-table :items="eventsSelected" :fields="eventsFields"
                         :current-page="eventsCurrentPage" :per-page="5"
                         :selected-variant="Variant" overflow-y="hidden"
                         :sort-by.sync="eventsSortBy" :sort-desc.sync="eventsSortDesc" :sort-direction="eventsSortDirection"
                         show-empty :hover="true"
                         class="w-100">

                    <template #cell(actions)="row">
                        <b-button size="sm" @click="row.toggleDetails" :variant="'outline-' + Variant">
                            {{ row.detailsShowing ? '-' : '+' }}
                        </b-button>
                    </template>

                    <template #row-details="row">
                        <b-card header-class="pb-1 border border-top-0 border-left-0 border-right-0 border-light"
                                class="d-flex overflow-auto" body-class="p-1 w-100 d-flex overflow-auto text-break text-wrap">
                            <template #header>
                                <h6>
                                    {{ $t('MessageDetails') }}
                                </h6>
                            </template>
                            {{ row.item.description }}
                        </b-card>
                    </template>
                </b-table>
            </b-row>
            <template #modal-footer="{ close }">
                <b-pagination v-model="eventsCurrentPage" :total-rows="eventsSelected.length" :per-page="5" align="fill"
                              class="my-0 mr-auto" :variant="Variant">
                </b-pagination>
                <b-button pill :variant="'outline-' + Variant" @click="close; eventModalVisible = false">{{ $t('Close') }}</b-button>
            </template>
        </b-modal>
    </b-container>
</template>

<script lang="ts">
import { Prop, PropSync, Vue, Watch } from "vue-property-decorator";
import Component, {mixins} from 'vue-class-component';
import { ThemeUtils } from "@/components/commons/Utils";
import HscMenuStyleCustom from '@/components/commons/HscMenuStyleCustom';
import ECharts from 'vue-echarts';
import * as echarts from 'echarts/core';
import {
    BarChart,
    LineChart,
    PieChart,
    ScatterChart,
    SunburstChart,
    CustomChart,
} from 'echarts/charts';
import {
    TitleComponent,
    TooltipComponent,
    GridComponent,
    DatasetComponent,
    TransformComponent,    // Built-in transform (filter, sort)
    LegendComponent,
    ToolboxComponent,
    DataZoomComponent,
    MarkLineComponent,
} from 'echarts/components';
import {LabelLayout, UniversalTransition} from 'echarts/features';
import {SVGRenderer} from 'echarts/renderers';
import Menu from "./Menu.vue";
import {ExternalDataTransformResultItem} from "echarts/types/src/data/helper/transform";
import Dictionary from "@/types/Dictionary";
import moment, {Moment} from "moment/moment";
import ChartUtils from "@/components/commons/ChartUtils";
import DefaultTheme from '@/assets/ECharts/themes/default-theme.json';
import LightOrangeTheme from '@/assets/ECharts/themes/light-orange-theme.json';
import DarkOrangeTheme from '@/assets/ECharts/themes/dark-orange-theme.json';
import LightPinkTheme from '@/assets/ECharts/themes/light-pink-theme.json';
import DarkPinkTheme from '@/assets/ECharts/themes/dark-pink-theme.json';
import LightPurpleTheme from '@/assets/ECharts/themes/light-purple-theme.json';
import DarkPurpleTheme from '@/assets/ECharts/themes/dark-purple-theme.json';
import LightMacaronsTheme from '@/assets/ECharts/themes/light-macarons-theme.json';
import DarkMacaronsTheme from '@/assets/ECharts/themes/dark-macarons-theme.json';
import LightAllColorsTheme from '@/assets/ECharts/themes/light-allcolors-theme.json';
import DarkAllColorsTheme from '@/assets/ECharts/themes/dark-allcolors-theme.json';
import ChartWorkEvolution from '@/components/commons/Work/ChartWork/ChartWorkEvolution.vue';
import ChartWorkBenchmarking from '@/components/commons/Work/ChartWork/ChartWorkBenchmarking.vue';
import ChartWorkUnitCost from '@/components/commons/Work/ChartWork/ChartWorkUnitCost.vue';
import ChartWorkGoal from '@/components/commons/Work/ChartWork/ChartWorkGoal.vue';
import {WorkExtended} from "@/components/commons/Work";
import {StringUtils} from "@/components/commons/Utils";
import ChartContext from "./ChartWork/ChartContext";
import ChartState from "./ChartWork/ChartState";
import locales from "./locales/ChartWork.json";

// Register the required components
echarts.use([
    TitleComponent,
    TooltipComponent,
    GridComponent,
    DatasetComponent,
    TransformComponent,
    BarChart,
    LineChart,
    PieChart,
    SunburstChart,
    ScatterChart,
    CustomChart,
    LabelLayout,
    UniversalTransition,
    SVGRenderer,
    LegendComponent,
    ToolboxComponent,
    DataZoomComponent,
    MarkLineComponent,
]);

/** Composant d'affichage de graphique ECharts */
@Component({
    components: {
        'v-chart': ECharts,
        'chart-menu': Menu,
        'hsc-menu-style-custom': HscMenuStyleCustom("secondary"),
        'chart-work-Evolution': ChartWorkEvolution,
        'chart-work-Benchmarking': ChartWorkBenchmarking,
        'chart-work-UnitCost': ChartWorkUnitCost,
        'chart-work-Goal': ChartWorkGoal
    },
    i18n : {messages : locales }
})
export default class ChartWork extends mixins(WorkExtended<ChartContext>, ChartUtils, StringUtils, ThemeUtils) {

    /** Mettre le graphique en SVG */
    private init_options: any = {renderer: 'svg'};

    /**
     * Identifiant du widget si le graphique est affiché dans un widget sinon 0
     * @todo A supprimer et à remplacer par un $id() car le ChartWork n'est pas forcément dans un Widget...
     */
    @Prop({default: 0})
    public WidgetId!: number;

    private messages: string[] = [];

    private eventModalVisible: boolean = false;
    private eventsSelected: any = {};
    private eventsStartDate: string;
    private eventsCurrentPage: number = 1;
    private eventsFields: any[] = [
        { key: 'actions', label: '' },
        { key: 'date', label: this.$t("Date").toString(), sortable: true, class: 'text-center',
            formatter: (value, key, item) => {
                return this.$options.filters.formatDate(value, 'DD/MM/YYYY');
            }
        },
        { key: 'name', label: this.$t("Object").toString(), sortable: true, class: 'text-nowrap' },
        { key: 'description', label: this.$t("Message").toString() , sortable: true, class: 'w-100 eventDescription text-truncate' },
    ];
    private eventsSortBy: string = '';
    private eventsSortDesc: boolean = false;
    private eventsSortDirection: string = 'asc';

    /** Passage ou non en fullScreen */
    @Watch('fullscreen')
    public changeFullscreen() {
        console.debug("ChartWork - changeFullscreen() - this.context : ", this.context);

        if (this.context) {
            console.debug("ChartWork - changeFullscreen() - fullscreen : %O", this.fullscreen);
            if (this.fullscreen)
                this.context.GoFullscreen();
            else
                this.context.GoStandard();
        }
        this.chartTransformFunctions();
        console.debug('ChartWork.vue - changeFullscreen - fullscreen : %100', this.fullscreen);

        var img = new Image();
        img.src = (this.$refs as any).chart.getDataURL({
            //pixelRatio: 2,
            backgroundColor: '#fff',
            excludeComponents: ['dataZoom'],
        });

        this.chartColorsToConfigs();
        this.configs.WorkParameters.ChartWorkParameters.image = img.src;
        console.debug('chartColorsToConfigs - image', img.src);
    }

    /** Rafraichissement des données sur changement - OPTION */
    @Watch('Loading', {immediate: true, deep: true})
    public refreshLoading() {
        console.debug('ChartWork.vue - refreshLoading() - results', this.results);
        console.debug('ChartWork.vue - refreshLoading() - Loading', this.Loading);

        let echartsTooltip = document.getElementsByClassName('echarts-tooltip');
        if (echartsTooltip != undefined && echartsTooltip.length > 0) {
            for (let i = echartsTooltip.length - 1; i >= 0; i--) {
                echartsTooltip[i].remove();
            }
            console.debug('ChartWork.vue - refreshLoading() - remove echarts-tooltip class');
        }

        if (!this.Loading && this.results && ('option' in this.results) && this.results.option) {
            console.debug("ChartWork.vue - refreshLoading() - State - this.context : ", this.context);

            this.changeState(this.configs.WorkParameters.ChartWorkParameters.graphType, undefined);
            console.debug("ChartWork.vue - refreshLoading() - State - this.context : ", this.context);
            if (this.context) {
                // Mise à jour des valeurs du context suites au chargement.
                this.context.ChangeContext(this.results, this.configs);
                console.debug("ChartWork.vue - refreshLoading() - State - this.context : ", this.context);
            }
            this.chartTransformFunctions();
        }
        this.messages = []; // pour supprimer le message de changement de type

        this.chartColorsToConfigs();
    }

    /** Application des transformations pour les propriétés EChart de string à fonction */
    private chartTransformFunctions() {
        // Echarts - Modification des libellés des fonctions en fonction (JSON ne transfert que du string...)
        if (this.results && ('option' in this.results) && this.results.option) {
            this.TransformFunctions(this.results.option, this.FunctionsList);
            console.debug('ChartWork.vue - chartTransformFunctions - option',
                this.results && ('option' in this.results) && this.results.option ? this.results.option : undefined);
        }

        // Menu - Modification des libellés des fonctions en fonction (JSON ne transfert que du string...)
        if (this.results && ('menus' in this.results) && this.results.menus) {
            console.debug('menuTransformFunctions', this.results.menus);
            for (let i = 0; i < this.results.menus.length; i++) {
                let val = this.results.menus[i];
                console.debug('menuTransformFunctions - val', val);
                this.menuTransformFunctions(val);
            }
        }
    }

    /** Transformation des fonctions ECharts */
    private menuTransformFunctions(menu) {
        console.debug('menuTransformFunctions - menu', menu, menu.format);
        if (menu.format != undefined && menu.format != "") {
            let value = menu.format;
            console.debug('menuTransformFunctions - menu.format', menu.format);
            if (Object.keys(this.FunctionsList).find(val => val == value)) {
                menu.format = this.FunctionsList[value];
            }
        }
        if (('group' in menu) && menu.group) {
            for(let j = 0; j < menu.group.length; j++) {
                let valGroup = menu.group[j];
                if (('params' in valGroup) && valGroup.params) {
                    console.debug('menuTransformFunctions - params', menu, valGroup.params);
                    for (let i = 0; i < valGroup.params.length; i++) {
                        let valParam = valGroup.params[i];
                        this.menuTransformFunctions(valParam);
                    }
                }
            }
        }
    }

    /** Récupération des couleurs de thème du graphique */
    private chartColorsToConfigs() {
        if (this.$refs.chart != undefined && ('chart' in this.$refs.chart) && (this.$refs.chart as any).chart != undefined
            && ('_theme' in (this.$refs.chart as any).chart) && (this.$refs.chart as any).chart._theme != undefined
            && ('color' in (this.$refs.chart as any).chart._theme) && Array.isArray((this.$refs.chart as any).chart._theme.color))
            this.configs.WorkParameters.ChartWorkParameters.colors = (this.$refs.chart as any).chart._theme.color;

        if (this.results != undefined && 'option' in this.results &&
            this.configs.WorkParameters.ChartWorkParameters.colors != undefined &&
            this.configs.WorkParameters.ChartWorkParameters.colors.length > 0) {
            for (let i = 0; i < this.results.option.series.length; i++) {
                if ('itemStyle' in this.results.option.series[i] && this.results.option.series[i].itemStyle != undefined
                    && ('color' in this.results.option.series[i].itemStyle))
                    this.configs.WorkParameters.ChartWorkParameters.colors[i] = this.results.option.series[i].itemStyle.color;
            }
        }
    }

    /**
     * Indique si le type de graphique dans la config est identique au nom du bouton.
     * @param workParameters
     * @param defaultValue
     * @private
     */
    private getConfigWorkParameters(workParameters: string[], defaultValue) {
        //console.debug("ChartWork.vue - getConfigWorkParameters() - paramètre d'entrée", workParameters, defaultValue);
        if (this.configs && ('WorkParameters' in this.configs)) {
            let config = this.configs.WorkParameters;
            for (let i = 0; i < workParameters.length; i++) {
                //console.debug('ChartWork.vue - getConfigWorkParameters() - workParameters[i] : ', workParameters[i], config);
                if ((workParameters[i] in config)) {
                    config = config[workParameters[i]];
                } else {
                    console.debug('ChartWork.vue - changeConfig() - break');
                    config = defaultValue;
                    break;
                }
            }

            return config;
        } else {
            //console.debug('ChartWork.vue - getConfigWorkParameters() - defaultValue :', defaultValue);
            return defaultValue;
        }
    }

    /** Changement du type de graphique via boutons */
    private changeTypeGraph(value: string) {
        let oldValue = this.getConfigWorkParameters(['ChartWorkParameters', 'graphType'], 'bar');
        console.debug('ChartWork.vue - changeTypeGraph() - oldValue, newValue :', oldValue, value);

        this.changeConfigWorkParameters(['ChartWorkParameters', 'graphType'], value, 'bar');
        if (this.configs && ('WorkParameters' in this.configs) && this.configs.WorkParameters
            && ('ChartWorkParameters' in this.configs.WorkParameters) && this.configs.WorkParameters.ChartWorkParameters
            && ('yAxis' in this.configs.WorkParameters.ChartWorkParameters) && this.configs.WorkParameters.ChartWorkParameters.yAxis
            && Array.isArray(this.configs.WorkParameters.ChartWorkParameters.yAxis)
            && ('length' in this.configs.WorkParameters.ChartWorkParameters.yAxis)) {
            for (let a = 0; a < this.configs.WorkParameters.ChartWorkParameters.yAxis.length; a++) {
                let result = this.changeConfigWorkParameters(['ChartWorkParameters', 'yAxis', a.toString(), 'type'], value, 'bar');
                if (result == 'line') {
                    this.changeConfigWorkParameters(['ChartWorkParameters', 'yAxis', a.toString(), 'subType'], {
                        smooth: false,
                        step: false
                    }, undefined);
                } else {
                    this.changeConfigWorkParameters(['ChartWorkParameters', 'yAxis', a.toString(), 'subType'], undefined, undefined);
                }
            }
            // @todo : mettre le bouton Actualiser en couleur. L'utilisateur doit actualiser le graphique pour changer de type.
        }
    }

    /** Change la valeur de la Config au niveau des Works */
    private changeConfigWorkParameters(workParameters: string[], value, defaultValue, funct: string = undefined): any {
        console.debug("ChartWork.vue - changeConfigWorkParameters() - paramètre d'entrée", workParameters, value, defaultValue);
        if (this.configs && ('WorkParameters' in this.configs)) {
            let config = this.configs.WorkParameters;
            for (let i = 0; i < workParameters.length; i++) {
                console.debug('ChartWork.vue - changeConfigWorkParameters() - workParameters[i] : ', workParameters[i], config);
                if ((workParameters[i] in config)) {
                    if (i == workParameters.length - 1) {
                        if (value != config[workParameters[i]]) {
                            Vue.set(config, workParameters[i], value);
                            console.debug('ChartWork.vue - changeConfigWorkParameters() - this.configs, value 1 :', this.configs, value);
                        }
                    } else {
                        if (config != config[workParameters[i]]) {
                            config = config[workParameters[i]];
                            console.debug('ChartWork.vue - changeConfigWorkParameters() - this.configs, value 2 :', this.configs, value);
                        }
                    }
                } else if (i == workParameters.length - 1) {
                    if (value != config[workParameters[i]]) {
                        Vue.set(config, workParameters[i], value);
                        console.debug('ChartWork.vue - changeConfigWorkParameters() - this.configs, value 3:', this.configs, value);
                    }
                } else {
                    console.debug('ChartWork.vue - changeConfigWorkParameters() - break');
                    break;
                }
            }
            return value;
        } else {
            console.debug('ChartWork.vue - changeConfigWorkParameters() - defaultValue :', defaultValue);
            return defaultValue;
        }
    }

    /** Changement au niveau du graphique */
    protected chartFinished() {
        console.debug('ChartWork.vue - chartFinished');
        this.chartAxis();
        this.chartColorsToConfigs();
    }

    /** Changement au niveau du zoom du graphique */
    protected chartDatazoom() {
        console.debug('ChartWork.vue - chartDatazoom');
        this.chartAxis();
    }

    protected chartClick(param) {
        if (param.componentSubType == 'custom' && param.componentType == 'series' && ('events' in param.data)) {
            console.debug('ChartWork.vue - chartClick', param);

            this.eventModalVisible = true;

            this.eventsSelected = [];
            if (!Array.isArray(param.data.events))
                this.eventsSelected.push(param.data.events);
            else
                this.eventsSelected = param.data.events;

            this.eventsStartDate = this.results.option.xAxis[0].axisLabel.formatter(param.data.name);

            this.eventsCurrentPage = 1;
            this.eventsSortBy = '';
            this.eventsSortDesc = false;
            this.eventsSortDirection = 'asc';

            console.debug('ChartWork.vue - chartClick - this.eventsSelected', this.eventsSelected);
        }
    }

    /** Pour le repositionnement des axes */
    private chartAxis() {
        if (this.configs && ('Feature' in this.configs) && this.configs.Feature === 'Benchmarking') {
            if (this.results && ('option' in this.results) &&
                this.results.option && ('dataset' in this.results.option) &&
                this.results.option.dataset) {
                let graphType = this.getConfigWorkParameters(['ChartWorkParameters', 'graphType'], 'BarLine');
                if (graphType === 'Scatter2D' || graphType === 'Scatter3D') {
                    let valueXList = [];
                    let valueYList = [];
                    for (let i = 0; i < this.results.option.dataset.length; i++) {
                        let source = this.results.option.dataset[i].source;
                        if (source) {
                            for (let a = 0; a < source.length; a++) {
                                let sourceValues = source[a];
                                if ('initValue' in sourceValues)
                                    sourceValues = sourceValues.initValue;

                                let value1 = getValueChart({
                                        value1: sourceValues.value1,
                                        factors: sourceValues.factors
                                    },
                                    {
                                        units: this.results.units,
                                        works: this.configs.WorkParameters.CommonWorkParameters,
                                        data: 0
                                    }, 'value');
                                if (value1 != undefined)
                                    valueXList.push(value1);

                                let value2 = getValueChart({
                                        value2: sourceValues.value2,
                                        factors: sourceValues.factors
                                    },
                                    {
                                        units: this.results.units,
                                        works: this.configs.WorkParameters.CommonWorkParameters,
                                        data: 1
                                    }, 'value');
                                if (value2 != undefined)
                                    valueYList.push(value2);
                                console.debug('ChartWork.vue - chartAxis - value1, value2', value1, value2);
                            }
                        }
                    }
                    let valueX = 0;
                    let valueY = 0;

                    if (valueXList.length > 0)
                        valueX = this.median(valueXList);
                    if (valueYList.length > 0)
                        valueY = this.median(valueYList);

                    /** Position du moint médian */
                    let chartPixelX = (this.$refs as any).chart?.convertToPixel({xAxisIndex: 0}, [valueX]);
                    let chartPixelY = (this.$refs as any).chart?.convertToPixel({yAxisIndex: 0}, [valueY]);
                    console.debug('ChartWork.vue - chartAxis - valueX, valueY, chartX, chartY', valueX, valueY, chartPixelX, chartPixelY);
                    /** Taille de la zone de ECharts */
                    let gridHeightPixel = (this.$refs as any).chart?.getHeight();
                    let gridWidthPixel = (this.$refs as any).chart?.getWidth();
                    console.debug('ChartWork.vue - chartAxis - Width, Height', gridHeightPixel, gridWidthPixel);
                    /** Position du point (0,0) */
                    let chartPixelX0 = (this.$refs as any).chart?.convertToPixel({xAxisIndex: 0}, [0]);
                    let chartPixelY0 = (this.$refs as any).chart?.convertToPixel({yAxisIndex: 0}, [0]);
                    console.debug('ChartWork.vue - chartAxis - 0', chartPixelX0, chartPixelY0);

                    if (valueX != 0 && chartPixelY != undefined) {
                        let offset = (chartPixelY - chartPixelY0);
                        console.debug('ChartWork.vue - chartAxis - XAxis - grid, offset', gridHeightPixel - 120, Math.abs(offset));
                        if (gridHeightPixel - 145 < Math.abs(offset)) {
                            /** L'axe est en dehors du graphique */
                            offset = 0;
                        }
                        Vue.set(this.results.option.xAxis[0], 'offset', offset);
                        Vue.set(this.results.option.xAxis[0].axisLabel, 'margin', offset * (-1) + 8);
                        Vue.set(this.results.option.xAxis[0], 'nameGap', offset * (-1) + 15);
                        Vue.set(this.results.option.xAxis[0].axisPointer.label, 'margin', offset * (-1) + 3);
                    }
                    if (valueY != 0 && chartPixelX != undefined) {
                        let offset = (chartPixelX - chartPixelX0) * (-1);
                        console.debug('ChartWork.vue - chartAxis - YAxis - grid, offset', gridWidthPixel - 120, Math.abs(offset));
                        if (gridWidthPixel - 140 < Math.abs(offset)) {
                            /** L'axe est en dehors du graphique */
                            offset = 0;
                        }
                        Vue.set(this.results.option.yAxis[0], 'offset', offset);
                        Vue.set(this.results.option.yAxis[0].axisLabel, 'margin', offset * (-1) + 8);
                        Vue.set(this.results.option.yAxis[0], 'nameGap', offset * (-1) + 45);
                        Vue.set(this.results.option.yAxis[0].axisPointer.label, 'margin', offset * (-1) + 3);
                    }
                }
            }
        }
    }

    /**
     * Changement au niveau du graphique des éléments sélectionnés du graphique
     * @param axis
     * @param menu
     * @param groupMenu
     */
    public transformMenu(axis: string, index: number, menu, groupMenu, imputValue) {
        console.debug("ChartWork.vue - transformMenu() - menu : ", axis, index, menu);
        if (menu && ('transform' in menu) && menu.transform) {
            let axisMenu = axis == 'xAxis' ? this.results.xAxis : this.results.yAxis;

            console.debug("ChartWork.vue - transformMenu() - menu.transform.type : ", menu.transform.type);
            switch (menu.transform.type) {
                // cacher le label de l'axe.
                case 'axisTitle' :
                    this.transformAxisTitle(axis, index, menu, axisMenu);
                    break;
                case 'series' :
                    this.transformSeries(index, menu, imputValue);
                    break;
                case 'format' :
                    this.transformFormat(axis, index, menu);
                    break;
                case 'transform' :
                    this.transformDatas(axis, index, menu, axisMenu);
                    break;
                case 'angles':
                    this.transformAngle(axis, index, menu);
                    break;
                case 'legend':
                    this.transformLegend(index, menu);
            }
            this.closeMenu(axis, index);

            if (!('WorkParameters' in this.configs) || this.configs.WorkParameters === undefined
                || this.configs.WorkParameters == null)
                this.configs.WorkParameters['ChartWorkParameters'] = {};

            console.debug('ChartWork.vue - transformMenu() - menu.configPath', menu.configPath);
            console.debug('ChartWork.vue - transformMenu() - Configs', this.configs);
        }
    }

    /**
     * Application de la transformation à partir du menu pour le type Titre
     * @param axisType
     * @param index
     * @param menuConfig
     * @param axisConfig
     * @private
     */
    private transformAxisTitle(axisType: string, index: number, menuConfig, axisConfig) {
        if (menuConfig.transform.function == 'hideTitle') {
            let axisEcharts = this.results.option[axisType];
            console.debug("ChartWork.vue - transformAxisTitle() - axisTitle - axisOption : ", axisType, index, axisEcharts,
                axisEcharts.id, axisConfig, axisConfig[index].axisName);
            let selected = this.getConfigWorkParameters(menuConfig.configPath[0].path, undefined) == true;
            axisEcharts[index].name = selected ? '{a|' + axisConfig[index].axisName + '\n}' +
                (axisConfig[index].unitName ? '{b|' + axisConfig[index].unitName + '}' : '') :
                (axisConfig[index].unitName ? '{b|' + axisConfig[index].unitName + '}' : '');

            // Mise à jour de la valeur en fonction de la sélection du menu
            for (let a = 0; a < menuConfig.configPath.length; a++) {
                console.debug('ChartWork.vue - transformAxisTitle() - menu.configPath - modif', menuConfig.configPath[a].path, !selected, menuConfig.configPath[a].selectedValue);
                this.changeConfigWorkParameters(menuConfig.configPath[a].path, !selected, menuConfig.configPath[a].selectedValue);
            }
        }
    }

    /**
     * Application de la transformation à partir du menu pour le type Format
     * @param axisType
     * @param index
     * @param menuConfig
     * @private
     */
    private transformFormat(axisType: string, index: number, menuConfig) {
        console.debug('ChartWork.vue - transformFormat() - format', index, menuConfig, this.results.option)
        let axisOption = this.results.option[axisType];
        axisOption[index].axisPointer.label.formatter = this.FunctionsList[menuConfig.transform.function];
        if (('config' in menuConfig.transform) && menuConfig.transform.config
            && ('value' in menuConfig.transform.config) && menuConfig.transform.config.value != undefined) {
            // Mise à jour de la valeur en fonction de la sélection du menu
            for (let a = 0; a < menuConfig.configPath.length; a++) {
                console.debug('ChartWork.vue - transformFormat() - menu.configPath - modif', menuConfig.configPath[a].path,
                    menuConfig.transform.config.value, menuConfig.configPath[a].selectedValue);
                this.changeConfigWorkParameters(menuConfig.configPath[a].path, menuConfig.transform.config.value,
                    menuConfig.configPath[a].selectedValue);
            }
        }
    }

    /**
     * Application de la transformation à partir du menu pour le type Angle
     * @param axisType
     * @param index
     * @param menuConfig
     * @private
     */
    private transformAngle(axisType: string, index: number, menuConfig) {
        let axis = this.results.option[axisType];
        console.debug("ChartWork.vue - transformAngle() - angles : ", index, axisType, axis);
        axis[index].axisLabel.rotate = menuConfig.transform.config.angle;

        // Mise à jour de la valeur en fonction de la sélection du menu
        for (let a = 0; a < menuConfig.configPath.length; a++) {
            console.debug('ChartWork.vue - transformAngle() - menu.configPath - modif', menuConfig.configPath[a].path,
                axis[index].axisLabel.rotate, menuConfig.configPath[a].selectedValue);
            this.changeConfigWorkParameters(menuConfig.configPath[a].path, menuConfig.configPath[a].selectedValue,
                menuConfig.configPath[a].selectedValue);
        }
    }

    /**
     * Application de la transformation à partir du menu pour le type Series
     * @param index
     * @param menuConfig
     * @param imputValue
     * @private
     */
    private transformSeries(index: number, menuConfig, imputValue) {
        console.debug('ChartWork.vue - transformSeries() - series', index, menuConfig, menuConfig);
        let nbSeriesStack = 0;
        for (let i = 0; i < this.results.option.series.length; i++) {
            let serie = this.results.option.series[i];
            let serieIdList = serie.id.split(/[Ax|Data|Val]/g).filter((a) => a.length > 0);
            let serieId: string | number = 1;
            if (serieIdList.length > 0) {
                serieId = serieIdList[1]; /// Numéro de la donnée
                if (typeof serieId == 'string' && (serieId as string).includes('Prd')) {
                    let serieIdListTemp = serieId.split(/[Prd]/g).filter((a) => a.length > 0);
                    serieId = serieIdListTemp[0];
                }
            }
            console.debug('ChartWork.vue - transformSeries() - serieId', serieId);
            if (serieId == index + 1) {
                console.debug('ChartWork.vue - transformSeries() - series - serie', serie, serie.barWidth);
                if (menuConfig.transform.function == 'stackSeries') {
                    if (serie.id.includes(menuConfig.transform.config.stack)) {
                        let period: string = '';
                        if (serieIdList[0].indexOf('Prd') >= 0) {
                            let seriePeriod = serieIdList[0].split(/[Prd]/g).filter((a) => a.length > 0);
                            period = seriePeriod[1];
                            console.debug('ChartWork.vue - transformSeries() - period', period);
                        }
                        let selected = !this.getConfigWorkParameters(menuConfig.configPath[0].path, false) == true;
                        let stack = (period.length > 0 ? 'Prd' + period : '') + 'Data' + serieId; /// Numéro de la donnée
                        serie.stack = selected ? stack : undefined;
                        nbSeriesStack += 1;
                        //serie.barWidth = serie.stack != undefined ? "80%" : (80 / this.results.option.series.length) + "%";
                        console.debug('ChartWork.vue - transformSeries() - series - stackSeries - serie, serieIdList, stack, serie.stack, menu :',
                            serie, serieIdList, stack, serie.stack, selected);
                    }
                } else if (menuConfig.transform.function == 'typeSeries') {
                    let configType = menuConfig.transform.config.type;
                    serie.type = menuConfig.transform.config.type;
                    console.debug('ChartWork.vue - transformSeries() - typeSeries');

                    let subType: any = undefined;
                    if (serie.type == 'line') {
                        serie.type = 'line';
                        serie.smooth = menuConfig.transform.config.smooth;
                        serie.step = menuConfig.transform.config.step;
                        (this.$refs.chart as any).setOption(this.results.option);
                        console.debug('ChartWork.vue - transformSeries() - subType', subType);

                        Vue.set(serie, 'areaStyle', menuConfig.transform.config.areaStyle);
                        console.debug('ChartWork.vue - transformSeries() - subType', subType);

                        if (serie.areaStyle != null && serie.areaStyle != undefined) {
                            configType = 'area';
                        }
                        subType = {
                            type: configType,
                            smooth: menuConfig.transform.config.smooth,
                            step: menuConfig.transform.config.step
                        };
                    }

                    // Mise à jour de la valeur en fonction de la sélection du menu
                    for (let a = 0; a < menuConfig.configPath.length; a++) {
                        if (menuConfig.configPath[a].path.findIndex(a => a == 'subType') >= 0) {
                            console.debug('ChartWork.vue - transformSeries() - menu.configPath[a].path, subType, menu.configPath[a].selectedValue',
                                menuConfig.configPath[a].path, subType, menuConfig.configPath[a].selectedValue);
                            this.changeConfigWorkParameters(menuConfig.configPath[a].path, subType, menuConfig.configPath[a].selectedValue);
                        } else if (menuConfig.configPath[a].path.findIndex(a => a == 'type') >= 0) {
                            console.debug('ChartWork.vue - transformSeries() - menu.configPath[a].path, serie.type, menu.configPath[a].selectedValue',
                                menuConfig.configPath[a].path, serie.type, menuConfig.configPath[a].selectedValue);
                            this.changeConfigWorkParameters(menuConfig.configPath[a].path, configType, menuConfig.configPath[a].selectedValue,
                                menuConfig.transform.function);
                        }
                    }
                } else if (menuConfig.transform.function == 'minLine' || menuConfig.transform.function == 'maxLine'
                    || menuConfig.transform.function == 'averageLine' || menuConfig.transform.function == 'medianLine') {
                    let selected = !this.getConfigWorkParameters(menuConfig.configPath[0].path, false) == true;
                    console.debug('ChartWork.vue - transformSeries() - minMoyMax - selected, serie.markLine',
                        selected, this.results.option.series[i].markLine);

                    let echartsType: { type: string, name: string } = {type: 'min', name: this.$t("Minimum").toString() /*'Minimum'*/};
                    switch (menuConfig.transform.function) {
                        case 'minLine':
                            echartsType = {type: 'min', name: this.$t("Minimum").toString() /*'Minimum'*/};
                            break;
                        case 'maxLine':
                            echartsType = {type: 'max', name: this.$t("Maximum").toString() /*'Maximum'*/};
                            break;
                        case'averageLine':
                            echartsType = {type: 'average', name: this.$t("Average").toString() /*'Moyenne'*/};
                            break;
                        case'medianLine':
                            echartsType = {type: 'median', name: this.$t("Median").toString() /*'Médiane'*/};
                            break;
                    }
                    if (selected) {
                        if (('markLine' in this.results.option.series[i]) && this.results.option.series[i].markLine
                            && ('data' in this.results.option.series[i].markLine) && this.results.option.series[i].markLine.data
                            && Array.isArray(this.results.option.series[i].markLine.data)) {
                            this.results.option.series[i].markLine.data.push(echartsType);
                        } else {
                            Vue.set(this.results.option.series[i], 'markLine', {data: [echartsType]});
                        }
                    } else {
                        if (('markLine' in this.results.option.series[i]) && this.results.option.series[i].markLine
                            && ('data' in this.results.option.series[i].markLine) && this.results.option.series[i].markLine.data
                            && Array.isArray(this.results.option.series[i].markLine.data)) {
                            let index = this.results.option.series[i].markLine.data.findIndex(a => a.type == echartsType.type);
                            if (index >= 0) {
                                let data = [];
                                for (let j = 0; j < this.results.option.series[i].markLine.data.length; j++) {
                                    if (this.results.option.series[i].markLine.data[j] != undefined && j != index)
                                        data.push(this.results.option.series[i].markLine.data[j]);
                                }
                                if (data.length > 0)
                                    this.results.option.series[i].markLine.data = data;
                                else
                                    this.results.option.series[i].markLine.data = undefined;
                            }
                        }
                    }
                    // Récupération du style
                    this.results.option.series[i].markLine.label = this.results.option.yAxis[0].axisLabel;
                    this.results.option.series[i].markLine.label.position = 'start';
                    this.results.option.series[i].markLine.precision = 3;


                    // Mise à jour de la valeur en fonction de la sélection du menu
                    for (let a = 0; a < menuConfig.configPath.length; a++) {
                        this.changeConfigWorkParameters(menuConfig.configPath[a].path, selected,
                            menuConfig.configPath[a].selectedValue);
                    }
                } else if (menuConfig.transform.function == 'nbValuesSeries') {
                    this.messages = [this.$t("ParameterChangeRequiresChartUpdated").toString()]; // 'Ce changement de paramètre nécessite une actualisation du graphique.'

                    console.debug('ChartWork.vue - transformSeries() - series - nbValuesSeries', imputValue);

                    for (let a = 0; a < menuConfig.configPath.length; a++) {
                        this.changeConfigWorkParameters(menuConfig.configPath[a].path, imputValue, undefined);
                    }
                } else if (menuConfig.transform.function == 'orderSeries') {
                    this.messages = [this.$t("ParameterChangeRequiresChartUpdated").toString()]; // 'Ce changement de paramètre nécessite une actualisation du graphique.'

                    console.debug('ChartWork.vue - transformSeries() - series - groupSeries', menuConfig);
                    for (let a = 0; a < menuConfig.configPath.length; a++) {
                        this.changeConfigWorkParameters(menuConfig.configPath[a].path,
                            menuConfig.configPath[0].selectedValue, 'descending');
                    }
                } else if (menuConfig.transform.function == 'groupSeries') {
                    this.messages = [this.$t("ParameterChangeRequiresChartUpdated").toString()]; // 'Ce changement de paramètre nécessite une actualisation du graphique.'

                    console.debug('ChartWork.vue - transformSeries() - series - groupSeries', menuConfig);
                    for (let a = 0; a < menuConfig.configPath.length; a++) {
                        this.changeConfigWorkParameters(menuConfig.configPath[a].path,
                            menuConfig.configPath[0].selectedValue, 'sum');
                    }
                } else if (menuConfig.transform.function == 'pieCenter') {
                    console.debug('ChartWork.vue - transformSeries() - series - pieCenter', imputValue);

                    for (let b = 0; b < this.results.option.series.length; b++) {
                        console.debug('ChartWork.vue - transformSeries() - series - pieCenter', this.results.option.series[b], ('radius' in this.results.option.series[b]) && this.results.option.series[b].radius
                            && Array.isArray(this.results.option.series[b].radius));
                        if (('radius' in this.results.option.series[b]) && this.results.option.series[b].radius
                            && Array.isArray(this.results.option.series[b].radius)) {

                            Vue.set(this.results.option.series[b],'radius', [(imputValue ?? '0') + '%',
                                this.results.option.series[b].radius[1]]);
                            console.debug('ChartWork.vue - transformSeries() - series - pieCenter', this.results.option.series[b].radius);
                        }
                        if (('levels' in this.results.option.series[b]) && this.results.option.series[b].levels
                            && Array.isArray(this.results.option.series[b].levels) && this.results.option.series[b].levels.length > 1
                            && ('radius' in this.results.option.series[b].levels[1]) && this.results.option.series[b].levels[1].radius
                            && Array.isArray(this.results.option.series[b].levels[1].radius)) {

                            Vue.set(this.results.option.series[b].levels[1],'radius', [(imputValue ?? '0') + '%',
                                this.results.option.series[b].levels[1].radius[1]]);
                            console.debug('ChartWork.vue - transformSeries() - series - pieCenter - raduis', this.results.option.series[b].levels[1].radius);
                        }
                    }

                    for (let a = 0; a < menuConfig.configPath.length; a++) {
                        this.changeConfigWorkParameters(menuConfig.configPath[a].path, imputValue, undefined);
                    }
                }
            }
        }

        if (nbSeriesStack > 0 && menuConfig.transform.function == 'stackSeries') {
            for (let i = 0; i < this.results.option.series.length; i++) {
                let serie = this.results.option.series[i];
                if (serie.yAxisIndex == index && serie.id.includes(menuConfig.transform.config.stack)) {
                    let pourcent = Number((serie.barWidth ?? '80%').replaceAll('%', ''));
                    serie.barWidth = (serie.stack != undefined ? pourcent * nbSeriesStack : pourcent / nbSeriesStack) + '%';
                    console.debug('ChartWork.vue - transformSeries() - stackSeries - nbSeriesStack, serie.barWidth, serie.stack', nbSeriesStack, serie.barWidth, serie.stack);
                    serie.barGap = 0;
                }
            }
        }
        if (menuConfig.transform.function == 'stackSeries') {
            let selected = !this.getConfigWorkParameters(menuConfig.configPath[0].path, undefined) == true;
            // Mise à jour de la valeur en fonction de la sélection du menu
            for (let a = 0; a < menuConfig.configPath.length; a++) {
                console.debug('ChartWork.vue - transformSeries() - stackSeries - menu.configPath, modif',
                    menuConfig.configPath[a].path, selected, menuConfig.configPath[a].selectedValue);
                this.changeConfigWorkParameters(menuConfig.configPath[a].path, selected, menuConfig.configPath[a].selectedValue);
            }
        }
    }

    /**
     * Application de la transformation à partir du menu pour le type Transformation
     * @param axisType
     * @param index
     * @param menuConfig
     * @param axisConfig
     * @private
     */
    private transformDatas(axisType: string, index: number, menuConfig, axisConfig) {
        let deleteTransform = false;
        if (menuConfig.formType == 'switch') {
            deleteTransform = menuConfig.selected;
        }

        // Mise à jour de la valeur en fonction de la sélection du menu
        for (let a = 0; a < menuConfig.configPath.length; a++) {
            console.debug('ChartWork.vue - transformDatas() - menu.configPath - modif', menuConfig.configPath[a].path,
                menuConfig.transform.config.value, menuConfig.configPath[a].selectedValue);
            this.changeConfigWorkParameters(menuConfig.configPath[a].path, menuConfig.configPath[a].selectedValue,
                menuConfig.configPath[a].selectedValue);
        }

        let config = Object.assign(menuConfig.transform.config);
        //config.axisInfo = axisConfig[index].unitGroups;
        config.units = this.results.units;
        config.works = this.configs.WorkParameters.CommonWorkParameters;
        console.debug('ChartWork.vue - transformDatas() - transform', index, menuConfig.transform.function, config, deleteTransform);
        this.transform(index, menuConfig.transform.function, config, deleteTransform);
        if (menuConfig.transform.linkTitle) {
            let axis = this.results.option[axisType];
            let axisIndex = axis[index];
            console.debug('ChartWork.vue - transformDatas() - title', this.results.option, index, axisIndex);

            // Reconstruction du titre de l'axe en fonction de la configuration
            let titleLabel = "";
            if (this.configs && ('WorkParameters' in this.configs) &&
                this.configs.WorkParameters && ('ChartWorkParameters' in this.configs.WorkParameters) &&
                this.configs.WorkParameters.ChartWorkParameters && (axisType in this.configs.WorkParameters.ChartWorkParameters) &&
                Array.isArray(this.configs.WorkParameters.ChartWorkParameters[axisType]) &&
                this.configs.WorkParameters.ChartWorkParameters[axisType].length > 0) {
                let axisArray = this.configs.WorkParameters.ChartWorkParameters[axisType];

                for (let a = 0; a < axisArray[index].units.length; a++) {
                    titleLabel += axisArray[index].units[a];
                }
            }

            const regex = /\{b\|.*\}/g;
            console.debug('ChartWork.vue - transformDatas() - titleLabel', titleLabel, axisIndex.name,
                axisIndex.name.replace(regex, "{b|" + titleLabel + "}"));
            axisIndex.name = axisIndex.name.replace(regex, "{b|" + titleLabel + "}"); // Ajout des 3 points verticaux et du style

            console.debug('ChartWork.vue - transformDatas() - titleLabel', axisIndex.name);
        }
    }

    /**
     * Application de la transformation à partir du menu pour le type Legend
     * @param index
     * @param menuConfig
     * @private
     */
    private transformLegend(index: number, menuConfig) {
        console.debug('ChartWork.vue - transformLegend() - index, menuConfig', index, menuConfig);
        if (menuConfig.transform.function == 'showLegend') {
            let selected = !this.getConfigWorkParameters(menuConfig.configPath[0].path, undefined) == true;
            this.results.option.legend.show = selected;
            this.results.option.grid[0].top = selected ? 55 : 35;

            if ('top' in this.results.option.series[0]) {
                this.results.option.series[0].top = selected ? 55 : 35;
            }

            // Mise à jour de la valeur en fonction de la sélection du menu
            for (let a = 0; a < menuConfig.configPath.length; a++) {
                console.debug('ChartWork.vue - transformSeries() - stackSeries - menu.configPath, modif',
                    menuConfig.configPath[a].path, selected, menuConfig.configPath[a].selectedValue);
                this.changeConfigWorkParameters(menuConfig.configPath[a].path, selected, menuConfig.configPath[a].selectedValue);
            }
        }
    }

    /**
     *
     * @param functionName
     * @param config
     * @param deleteTransform
     * @private
     */
    private transform(index: number, functionName: string, config, deleteTransform: boolean = false) {
        if (deleteTransform && config.serieName != undefined) {
            console.debug('ChartWork.vue - transform - series', deleteTransform, config.serieName, this.results.option.series);
            let actualDatasetIndex = this.results.option.series.find(a => a.name.toString() == config.serieName.toString()).DatasetIndex;
            console.debug('ChartWork.vue - transform - actualDatasetIndex', actualDatasetIndex);

            let listDataset: { id: string, fromDatasetId: string }[] = [];
            let lastDatasetIndex: number = actualDatasetIndex
            while (lastDatasetIndex != undefined && lastDatasetIndex >= 0) {
                let dataset = this.results.option.dataset[lastDatasetIndex];
                listDataset.push({id: dataset.id, fromDatasetId: dataset.fromDatasetId});

                if (dataset.fromDatasetId != undefined)
                    lastDatasetIndex = this.results.option.dataset.findIndex(a => a.id == dataset.fromDatasetId);
                else
                    lastDatasetIndex = undefined;
            }
            console.debug('ChartWork.vue - transform - listDataset', listDataset);
            /*            let indexList: number[] = [];
                        this.results.option.dataset.forEach(function (dataset, index) {
                            if (dataset.id.includes(functionName.split(':')[1])) {
                                indexList.push(index);
                            }
                        });
                        indexList = indexList.sort((a, b) => b - a);
                        console.debug(indexList);*/
        } else {
            console.debug('ChartWork.vue - transform - series', config.serieName, this.results.option.series);
            if (this.results && ('option' in this.results) &&
                this.results.option && ('series' in this.results.option) &&
                Array.isArray(this.results.option.series) && this.results.option.series.length) {
                this.results.option.series.forEach(a => {
                    if (functionName.includes('cumulative') && a.name != config.serieName) {
                        return;
                    }

                    if (a.yAxisIndex == index && a.datasetIndex != undefined) {
                        let datasetIndex = a.datasetIndex;
                        if (this.results.option.dataset[datasetIndex].id.includes('tranformInitIndex_')
                            && this.results.option.dataset[datasetIndex].id.includes(functionName.split(':')[1])) {
                            datasetIndex = this.results.option.dataset[datasetIndex].id.split('_')[1];
                        }

                        this.results.option.dataset.push({
                            id: 'tranformInitIndex_' + datasetIndex + '_' + this.results.option.dataset.length + '_' + functionName.split(':')[1],
                            fromDatasetId: this.results.option.dataset[datasetIndex].id,
                            transform: [{
                                type: functionName,
                                config: config
                            }]
                        });
                        a.datasetIndex = this.results.option.dataset.length - 1;
                    }
                });
            }
        }
    }

    //// ATTENTION ! cette partie est utilisée lors de la modification du menu.
    /**
     * Fermeture du menu
     * @param axis
     * @private
     */
    private closeMenu(axis: string, index: number) {
        if (this.$refs != undefined) {
            let axisContextMenu = this.$refs[axis + 'ContextMenu'];
            if (axisContextMenu != undefined) {
                if (Array.isArray(axisContextMenu)) {
                    const menu = (this.$refs[axis + 'ContextMenu'] as any)[index].$refs.menu;
                    menu.close();
                } else {
                    const menu = (this.$refs[axis + 'ContextMenu'] as any).$refs.menu;
                    menu.close();
                }
            }
        }
    }

    //#region Tranformation des fonctions
    /**
     * Tableau contenant la liste de toutes les fonctions transformables.
     * Pour transmettre des variables Vue.js dans les fonctions Js, il faut utiliser le format (a,b) => { return a; }
     */
    public FunctionsList: any = {
        'EventsCustom': (param, api) => {
            console.debug('ChartWork.vue - FunctionsList - EventsCustom - param, api', param, api);

            let option: any = undefined;
            if (this && this.results && ('option' in this.results) && this.results.option) {
                option = {...this.results.option};
            } else if (this && ('Results' in this)) {
                let results: any = this["Results"];
                if (results && ('option' in results) && results.option) {
                    option = {...results.option};
                }
            } else if (this && this.$props && ('Result' in this.$props) && this.$props.Result &&
                ('option' in this.$props.Result) && this.$props.Result.option) {
                option = {...this.$props.Result.option};
            }

            /* TODO : à revoir - le variant n'est pas trouvé dans la cas de secondary ou WebConfig */
            let variant: any = '';
            if (this && this.Variant != undefined){
                variant = this.Variant;
            } else if (this && ('Variant' in this) && this['Variant'] != undefined) {
                variant = this['Variant'];
            } else if (this && this.$props && ('Variant' in this.$props) && this.$props.Variant != undefined) {
                variant = {...this.$props.Variant};
            } else if (this && this.$parent && ('Variant' in this.$parent) && this.$parent.Variant != undefined){
                variant = (this.$parent.Variant as any);
            }

            if (variant == undefined || variant == '')
                variant = 'secondary';
            let color = getComputedStyle(document.body).getPropertyValue('--' + variant);
            let colorLight = getComputedStyle(document.body).getPropertyValue('--' + variant + '-light');
            console.debug('ChartWork.vue - FunctionsList - EventsCustom - color', this, '--' + variant, color, colorLight);

            const point = api.coord([api.value(0), 0]);

            console.debug('ChartWork.vue - FunctionsList - EventsCustom - param, api, option', param, api, option);

            if ('events' in option.dataset[0].source[param.dataIndex]) {
                return {
                    type: 'group',
                    children: [{
                        type: 'circle',
                        shape: {
                            r: 13,
                            cx: 10,
                            cy: 10,
                        },
                        style: {
                            fill: color,
                        },
                        position: [point[0] - 10, 40]
                    }, {
                        type: 'circle',
                        shape: {
                            r: 12,
                            cx: 10,
                            cy: 10,
                        },
                        style: {
                            fill: colorLight,
                        },
                        position: [point[0] - 10, 40]
                    }, {
                        type: 'path',
                        shape: {
                            pathData: 'M 0 0 A 1 1 0 0 0 0 -2 A 1 1 0 0 0 0 0 L 0.5 0 L 0.5 1 L 10 1 L 8 4 L 10 7 L 0.5 7 L 0.5 13 A 0.6 1 0 0 1 -0.5 13 L -0.5 0 L 0 0Z',
                            y: -9,
                            x: -7,
                            width: 17,
                            height: 17,
                        },
                        style: {
                            fill: color,
                        },
                        position: [point[0], 50]
                    }]
                };
            }
            else {
                return {
                    type: 'group',
                    children: [
                        {
                            type: 'text',
                            style: {
                                text: '',
                            }
                        }
                    ]
                };
            }
        },
        'UpperFirstLetter': (value) => {
            if (typeof (value) == 'object')
                return value.value.charAt(0).toUpperCase() + value.value.slice(1);
            else
                return value.charAt(0).toUpperCase() + value.slice(1);
        },
        'HourDateFormat': (value) => {
            return this.dateFormat(value, "L LT");
        },
        'DayDateFormat': (value) => {
            return this.dateFormat(value, "L");
        },
        'WeekDateFormat': (value) => {
            return this.dateFormat(value, "[S]ww YYYY");
        },
        'MonthDateFormat': (value) => {
            return this.dateFormat(value, "MMM YYYY");
        },
        'YearDateFormat': (value) => {
            return this.dateFormat(value, "YYYY");
        },
        'CompareHourDateFormat': (value) => {
            return this.dateFormat(value, "LT");
        },
        'CompareDayDateFormat': (value) => {
            return this.dateFormat(value, "dddd");
        },
        'CompareWeekDateFormat': (value) => {
            return this.dateFormat(value, "[S]ww");
        },
        'CompareMonthDateFormat': (value) => {
            return this.dateFormat(value, "MMM");
        },
        'CompareYearDateFormat': (value) => {
            return this.dateFormat(value, "YYYY");
        },
        'FrenchNumberFormat': (value) => {
            if (typeof (value) == 'object')
                return value.value.toLocaleString('fr-FR');
            else
                return value.toLocaleString('fr-FR');
        },
        'FrenchNumberFormatDigit': (value) => {
            if (typeof (value) == 'object')
                return Intl.NumberFormat('fr-FR').format(value.value);
            else
                return Intl.NumberFormat('fr-FR').format(value);
        },
        'FrenchNumberFormatDigit0': (value) => {
            return this.frenchNumberFormatDigit(value, 0);
        },
        'FrenchNumberFormatDigit1': (value) => {
            return this.frenchNumberFormatDigit(value, 1);
        },
        'FrenchNumberFormatDigit2': (value) => {
            return this.frenchNumberFormatDigit(value, 2);
        },
        'FrenchNumberFormatDigit3': (value) => {
            return this.frenchNumberFormatDigit(value, 3);
        },
        'Tooltip': (params, value) => {
            console.debug("ChartWork.vue - Tooltip - ", params, value);

            let configs: any = undefined;
            let option: any = undefined;
            let results: any = undefined;
            if (this && this.results && ('option' in this.results) && this.results.option) {
                results = {...this.results};
                option = {...this.results.option};
            } else if (this && ('Results' in this)) {
                results = this["Results"];
                if (results && ('option' in results) && results.option) {
                    option = {...results.option};
                }
            } else if (this && this.$props && ('Result' in this.$props) && this.$props.Result &&
                ('option' in this.$props.Result) && this.$props.Result.option) {
                results = {...this.$props.Result}
                option = {...this.$props.Result.option};
            }
            if (this && this.configs) {
                configs = {...this.configs};
            } else if (this && ('Configs' in this)) {
                configs = this["Configs"];
            } else if (this && this.$props && ('Configs' in this.$props)) {
                configs = {...this.$props.Configs};
            }

            let paramsArray = [];
            if (!Array.isArray(params))
                paramsArray.push(params);
            else
                paramsArray = params;

            let values: { serieName: string[], legend: string[], marker: string, value: string }[] = this.getValuesTooltip(paramsArray, results, option, configs);
            console.debug("ChartWork.vue - Tooltip - values ", values);
            if (values) {
                let xAxis = option.xAxis;
                let axisLabel;
                let axisLabelFunction = xAxis[params[0].axisIndex].axisPointer.label.formatter;
                console.debug("ChartWork.vue - Tooltip - a.value - axisLabelFunction ", xAxis[params[0].axisIndex], axisLabelFunction, typeof axisLabelFunction);
                if (typeof axisLabelFunction == 'function') {
                    axisLabel = axisLabelFunction(params[0].axisValue);
                } else {
                    axisLabel = this.FunctionsList[axisLabelFunction](params[0].axisValue);
                }
                console.debug("ChartWork.vue - Tooltip - axisLabel", axisLabel);
                let result = '<b>' + axisLabel + '</b>';

                // Liste des données possibles. Exemple : ["Donnée 1", "Donnée 2"]
                let datasList = values.map(a => a.serieName[0]).filter((value, index, array) => array.indexOf(value) === index);
                for (let i = 0; i < datasList.length; i++) {
                    // Liste des données utilisées.
                    let dataList = values.filter(a => a.serieName[0] == datasList[i]);
                    dataList = dataList.sort((a,b) => a.serieName.join(',') < b.serieName.join(',') ? -1 : 1 );

                    console.debug("ChartWork.vue - Tooltip - datasList[i], dataList, dataList.length", datasList[i], dataList, dataList.length);

                    result += '<div style="padding:5px">';
                    if (dataList.length > 1) {
                        let titleList = []
                        for (let k = 0; k < dataList.length; k++) {
                            let title = '';

                            let length = 1; // dans le cas où la legende containt qu'un seul élement (cas des objectifs)
                            if (dataList[k].legend.length > 1)
                                length = dataList[k].legend.length - 1;
                            for (let j = 0; j < length; j++) {
                                title += (title.length == 0 ? '' : ' - ') + dataList[k].legend[j];

                                console.debug("ChartWork.vue - Tooltip - dataList[k].legend[j] : %O", dataList[k].legend[j]);
                            }
                            titleList.push({
                                title: title,
                                legend: dataList[k].legend,
                                marker: dataList[k].marker,
                                value: dataList[k].value,
                            });
                        }
                        console.debug("ChartWork.vue - Tooltip - titleList", titleList);

                        let titleDistinctList = titleList.map(a => a.title)
                            .filter((value, index, array) => array.indexOf(value) === index);
                        console.debug("ChartWork.vue - Tooltip - titleDistinctList", titleDistinctList);

                        for (let k = 0; k < titleDistinctList.length; k ++) {
                            if (titleDistinctList[k] != undefined && titleDistinctList[k].length > 0) {
                                result += (k == 0 ? '' : '<br/>') + '<b>' + titleDistinctList[k] + ' : </b>';
                                console.debug("ChartWork.vue - Tooltip - titre", titleDistinctList[k]);

                                let dataTitreList = titleList.filter(a => a.title == titleDistinctList[k])
                                for (let j = 0; j < dataTitreList.length; j++) {
                                    if (dataTitreList[j].legend[dataTitreList[j].legend.length - 1] != 'event') {
                                        result += '<br/>' +
                                            dataTitreList[j].marker + dataTitreList[j].legend[dataTitreList[j].legend.length - 1] + ' : ' +
                                            dataTitreList[j].value;
                                    }
                                }
                            }
                        }
                    } else if (dataList.length == 1) {
                        let titre = '';
                        for (let j = 0; j < dataList[0].legend.length; j++) {
                            titre += (titre.length == 0 ? '' : ' - ') + dataList[0].legend[j];
                        }
                        if (titre != undefined && titre.length > 0 && titre != 'event') {
                            result += dataList[0].marker + '<b>' + titre + ' : </b>' + dataList[0].value;
                        }
                        console.debug("ChartWork.vue - Tooltip - titre", titre);
                    }
                    result += '</div>';

                    console.debug("ChartWork.vue - Tooltip - dataList", dataList);
                }
                console.debug("ChartWork.vue - Tooltip - result", result);
                return result;
            }
            return value;
        },
        'TooltipScatter': (params, value) => {
            console.debug("ChartWork.vue - TooltipScatter - ", params, value);

            let configs: any = undefined;
            let option: any = undefined;
            let results: any = undefined;
            if (this && this.results && ('option' in this.results) && this.results.option) {
                results = {...this.results};
                option = {...this.results.option};
            } else if (this && ('Results' in this)) {
                results = this["Results"];
                if (results && ('option' in results) && results.option) {
                    option = {...results.option};
                }
            } else if (this && this.$props && ('Result' in this.$props) && this.$props.Result &&
                ('option' in this.$props.Result) && this.$props.Result.option) {
                results = {...this.$props.Result}
                option = {...this.$props.Result.option};
            }
            if (this && this.configs) {
                configs = {...this.configs};
            } else if (this && ('Configs' in this)) {
                configs = this["Configs"];
            } else if (this && this.$props && ('Configs' in this.$props)) {
                configs = {...this.$props.Configs};
            }

            /*let dimension: any = a.dimensionNames.map((a, i) => ({
                name: a,
                index: i
            })).filter(a => a.name != undefined && a.name.includes('value'));
            if (dimension.length == undefined) {
                let dimensionArray: any[] = [];
                dimensionArray.push(dimension);
                dimension = dimensionArray;
            }*/

            let paramsArray = [];
            if (!Array.isArray(params))
                paramsArray.push(params);
            else
                paramsArray = params;

            let values: { serieName: string[], legend: string[], marker: string, value: string }[] = this.getValuesTooltip(paramsArray, results, option, configs);

            console.debug("ChartWork.vue - TooltipScatter - values", values);
            if (values) {

                let axisLabel = paramsArray[0].value.name;
                let result = '<b>' + axisLabel + '</b>';

                let axisName: string[] = ['xAxis', 'yAxis', 'zAxis'];

                let datasList = values.map(a => a.serieName[0]).filter((value, index, array) => array.indexOf(value) === index);

                console.debug("ChartWork.vue - TooltipScatter - datasList.length", datasList, datasList.length);
                for (let i = 0; i < datasList.length; i++) {

                    // Liste des données utilisées.
                    let dataList = values.filter(a => a.serieName[0] == datasList[i]);
                    console.debug("ChartWork.vue - TooltipScatter - dataList", dataList);

                    result += '<div style="padding:5px">';
                    let title = '';
                    for (let j = 0; j < dataList[0].legend.length; j++) {
                        title += (title.length == 0 ? '' : ' - ') + dataList[0].marker + dataList[0].legend[j];
                    }
                    result += '<b>' + title + ' : </b>';

                    for (let j = 0; j < dataList.length; j++) {
                        console.debug("ChartWork.vue - TooltipScatter - dataList", dataList, axisName, j, results);
                        let axis = results[axisName[j]];
                        result += '<br/>' + axis[0].axisName + ' : ' + dataList[j].value;
                    }
                    result += '</div>';
                }
                console.debug("ChartWork.vue - TooltipScatter - result", result);
                return result;
            }
            return value;
        },
        'Legend': (name) => {
            console.debug('ChartWork.vue - Legend - name', name);
            if (name == 'event'){
                return;
            }

            let pourcent = "";
            if (typeof (name) == "object" && ('percent' in name) && name.percent) {
                pourcent = " (" + name.percent + "%)";
            }

            let nameNiveau = [];
            let splitName = typeof (name.split) == 'function' ? name.split(' || ') : [name];
            if (typeof (name) == "object" && name.name) {
                splitName = typeof (name.name.split) == 'function' ? name.name.split(' || ') : [name.name];
            }
            nameNiveau.push(3);
            nameNiveau.push(4);

            let option: any = undefined;
            if (this && this.results && ('option' in this.results) && this.results.option) {
                option = {...this.results.option};
            } else if (this && ('Results' in this)) {
                let results: any = this["Results"];
                if (results && ('option' in results) && results.option) {
                    option = {...results.option};
                }
            } else if (this && this.$props && ('Result' in this.$props) && this.$props.Result &&
                ('option' in this.$props.Result) && this.$props.Result.option) {
                option = {...this.$props.Result.option};
            }
            let series = option.series;

            if (series != undefined) {
                let niveau: { niveau: number, values: string[] }[] = Array(6).fill(0);
                niveau = niveau.map((v, i) => ({niveau: i, values: []}));

                if (series && series.length > 0) {
                    for (let i = 0; i < series.length; i++) {
                        let serie = [];
                        if (typeof (series[i]) == "object" && series[i].name) {
                            serie = typeof (series[i].name.split) == 'function' ? series[i].name.split(' || ') : [series[i]];

                            console.debug("ChartWork.vue - Legend - niveau", niveau);
                            for (let j = 0; j < serie.length; j++) {
                                niveau[j].values.push(serie[j]);
                            }
                        } else if (typeof (series[i]) == "object" && !series[i].name && series[i].data) {
                            for (let j = 0; j < series[i].data.length; j++) {
                                if (typeof (series[i].data[j]) == "object" && series[i].data[j].name) {
                                    serie = typeof (series[i].data[j].name.split) == 'function' ? series[i].data[j].name.split(' || ') : [series[i].data[j]];
                                    for (let k = 0; k < serie.length; k++) {
                                        niveau[k].values.push(serie[k]);
                                    }
                                }
                            }
                        }
                    }
                }
                for (let i = 0; i < niveau.length; i++) {
                    if (niveau[i].values.length > 0) {
                        let values = niveau[i].values.filter((value, index, array) => array.indexOf(value) === index);
                        if (values.length > 1)
                            nameNiveau.push(niveau[i].niveau);
                    }
                }
                nameNiveau = nameNiveau.filter((value, index, array) => array.indexOf(value) === index).sort();

                if (nameNiveau.length > 0) {
                    let nameValue = '';
                    if (nameNiveau.find((e) => e < 3)) {
                        let index = nameNiveau.findIndex((e) => e == 0);
                        if (index >= 0)
                            nameNiveau.splice(index, 1);
                    }
                    for (let i = 0; i < nameNiveau.length; i++) {
                        if (splitName.length > nameNiveau[i]) {
                            let value = splitName[nameNiveau[i]];
                            if ((option.xAxis?.length ?? 0) > 0 && typeof (option.xAxis[0]?.axisLabel?.formatter) == 'function') {
                                let format: string = option.xAxis[0]?.axisLabel?.formatter.name;
                                if (format != undefined) {
                                    let newFormat = "";
                                    if (format?.includes("Compare"))
                                        newFormat = 'Compare';
                                    switch (format?.replace('Compare', '')) {
                                        case 'HourDateFormat':
                                            newFormat = 'DayDateFormat';
                                            break;
                                        case 'DayDateFormat':
                                            newFormat += 'WeekDateFormat';
                                            break;
                                        case 'WeekDateFormat':
                                        case 'MonthDateFormat':
                                        case 'YearDateFormat':
                                            newFormat += 'YearDateFormat';
                                            break;
                                    }
                                    if (newFormat != "")
                                        value = this.FunctionsList[newFormat](value);
                                }
                            }
                            nameValue += (nameValue == '' || value == '' ? '' : '\n') + value;
                        }
                    }
                    console.debug('ChartWork.vue - Legend - nameValue + pourcent', nameValue + pourcent);
                    return nameValue + pourcent;
                }
            } else if (typeof (name.replaceAll) == 'function') {
                console.debug('ChartWork.vue - Legend - name.replaceAll(\' || \', \'\\n\') + pourcent', name.replaceAll(' || ', '\n') + pourcent);
                return name.replaceAll(' || ', '\n') + pourcent;
            } else if (typeof (name) == "object" && name.name && typeof (name.name.replaceAll) == 'function') {
                console.debug('ChartWork.vue - Legend - name.name.replaceAll(\' || \', \'\\n\') + pourcent', name.name.replaceAll(' || ', '\n') + pourcent);
                return name.name.replaceAll(' || ', '\n') + pourcent;
            } else {
                console.debug('ChartWork.vue - Legend - name + pourcent', name + pourcent);
                return name + pourcent;
            }
        },
        'LegendSunburst': (params) => {
            if (params.data.name != undefined) {
                if (params.treePathInfo.length == 2)
                    return params.marker + '<b>' + params.data.name + ' : </b>' + params.data.value + '%';
                else if (params.treePathInfo.length == 3)
                    return params.marker + '<b>' + params.treePathInfo[1].name + ' - ' + params.data.name + ' : </b>' + params.data.value + '%';
            }
        },
        'SymbolSize': (data) => {
            return Math.sqrt(data.value3) * 0.1;
        },
    };

    /**
     * Formatage des nombres avec les chiffres derrières la virgule
     * @param value
     * @param num
     */
    private frenchNumberFormatDigit(value, num) {
        if (typeof (value) == 'object')
            return value.value.toLocaleString('fr-FR', {maximumFractionDigits: num, minimumFractionDigits: num});
        else
            return value.toLocaleString('fr-FR', {maximumFractionDigits: num, minimumFractionDigits: num});
    }

    /**
     * formatage de la valeur en date suivant le format
     * @param value
     * @param format
     */
    private dateFormat(value: any, format: string) {
        console.debug('chartWork.vue - dateFormat', value, format);
        let result: string = "";

        let valueString: string = "";
        if (typeof (value) == 'object')
            valueString = value.value;
        else
            valueString = value;
        let splitValue = valueString.split(' || ');

        for (let i = 0; i < splitValue.length; i++) {
            let date: moment.Moment = moment(splitValue[i], 'YYYY-MM-DDTHH:mm:ss', true);
            if(splitValue[i].includes("W")){
                // numéro de semaine
                date = moment(splitValue[i].split("W")[0]+'-01-01', "YYYY-MM-DD", true);
                date.add(splitValue[i].split("W")[1], 'weeks');
            }
            else if(splitValue[i].includes("D")) {
                // jour de la semaine
                date = moment(splitValue[i].split("D")[0]+'-10', "YYYY-MM-DD", 'en',true);
                date.startOf('week');
                date.add(splitValue[i].split("D")[1], 'days');
            }

            if (date.isValid()) {
                result += (result == '' ? '' : '\n') + date.lang(this.$store.getters['SessionStore/GetLanguage']).format(format);
            } else if (splitValue[i].length > 0) {
                result += (result == '' ? '' : '\n') + splitValue[i];
            }
        }
        return result;
    }

    /**
     * Récupération des valeurs en lien avec le tooltip
     * @param params
     */
    private getValuesTooltip(params, results, option, configs): { serieName: string[], legend: string[], marker: string, value: string }[] {
        console.debug("ChartWork.vue - getValuesTooltip", params, results, option, configs);

        let xAxis = option.xAxis;
        let yAxis = option.yAxis;
        let series = option.series;
        let legend = option.legend;
        console.debug("ChartWork.vue - getValuesTooltip - params", params);

        if (Array.isArray(params) && params.length > 0 && xAxis && Array.isArray(xAxis) && xAxis.length > (params[0].axisIndex ?? 0)) {
            let values: { serieName: string[], legend: string[], marker: string, value: string }[] = [];
            params.forEach(a => {
                console.debug("ChartWork.vue - getValuesTooltip - a", a);
                let legendName = '-';
                let formatLegendFunction = legend.formatter;
                console.debug("ChartWork.vue - getValuesTooltip - legend - formatFunction ", legend, formatLegendFunction);
                if (formatLegendFunction == undefined) {
                    legendName = a.seriesName;
                } else if (typeof formatLegendFunction == 'function') {
                    legendName = formatLegendFunction(a.seriesName);
                } else {
                    legendName = this.FunctionsList[formatLegendFunction](a.seriesName);
                }

                let dimension: any = a.dimensionNames.map((a, i) => ({
                    name: a,
                    index: i
                })).filter(a => a.name != undefined && a.name.includes('value'));
                if (dimension.length == undefined) {
                    let dimensionArray: any[] = [];
                    dimensionArray.push(dimension);
                    dimension = dimensionArray;
                }

                console.debug("ChartWork.vue - getValuesTooltip - dimension", dimension);
                for (let i = 0; i < dimension.length; i++) {
                    let formatFunction = undefined;
                    let unit = undefined;

                    let dimensionValue = dimension[i];
                    let getXValue: boolean = true;
                    let getYValue: boolean = true;
                    let getZValue: boolean = false;
                    if (dimension.length > 1) {
                        if (dimensionValue.name.includes('value1')) {
                            getXValue = true;
                            getYValue = false;
                            getZValue = false;
                        } else if (dimensionValue.name.includes('value2')) {
                            getXValue = false;
                            getYValue = true;
                            getZValue = false;
                        } else if (dimensionValue.name.includes('value3')) {
                            getXValue = false;
                            getYValue = false;
                            getZValue = true;
                        }
                    }

                    if (getXValue) {
                        for (let x = 0; x < a.encode.x; x++) {
                            if (a.encode.x[x] === dimensionValue.index) {
                                let xAxisIndex = dimensionValue.index;
                                if (series && Array.isArray(series) && series.length > 0 && series.length > a.seriesIndex
                                    && ('xAxisIndex' in series[a.seriesIndex])) {
                                    xAxisIndex = series[a.seriesIndex].xAxisIndex;
                                    unit = '';
                                    if (('WorkParameters' in configs) && configs.WorkParameters
                                        && ('ChartWorkParameters' in configs.WorkParameters) && configs.WorkParameters.ChartWorkParameters
                                        && ('xAxis' in configs.WorkParameters.ChartWorkParameters)
                                        && configs.WorkParameters.ChartWorkParameters.xAxis
                                        && Array.isArray(configs.WorkParameters.ChartWorkParameters.xAxis)
                                        && configs.WorkParameters.ChartWorkParameters.xAxis.length > xAxisIndex
                                        && ('units' in configs.WorkParameters.ChartWorkParameters.xAxis[xAxisIndex])
                                        && configs.WorkParameters.ChartWorkParameters.xAxis[xAxisIndex].units
                                        && Array.isArray(configs.WorkParameters.ChartWorkParameters.xAxis[xAxisIndex].units)
                                        && configs.WorkParameters.ChartWorkParameters.xAxis[xAxisIndex].units.length > 0) {
                                        for (let u = 0; u < configs.WorkParameters.ChartWorkParameters.xAxis[xAxisIndex].units.length; u++) {
                                            unit += configs.WorkParameters.ChartWorkParameters.xAxis[xAxisIndex].units[u];
                                        }
                                    }
                                    formatFunction = xAxis[xAxisIndex].axisPointer.label.formatter;
                                    console.debug("ChartWork.vue - getValuesTooltip - xAxisIndex - formatFunction, unit", formatFunction, unit);
                                }
                            }
                        }
                    }
                    if (getYValue) {
                        for (let y = 0; y < a.encode.y; y++) {
                            if (a.encode.y[y] === dimensionValue.index) {
                                let yAxisIndex = dimensionValue.index;
                                if (series && Array.isArray(series) && series.length > 0 && series.length > a.seriesIndex
                                    && ('yAxisIndex' in series[a.seriesIndex])) {
                                    yAxisIndex = series[a.seriesIndex].yAxisIndex;
                                    unit = '';
                                    if (('WorkParameters' in configs) && configs.WorkParameters
                                        && ('ChartWorkParameters' in configs.WorkParameters) && configs.WorkParameters.ChartWorkParameters
                                        && ('yAxis' in configs.WorkParameters.ChartWorkParameters)
                                        && configs.WorkParameters.ChartWorkParameters.yAxis
                                        && Array.isArray(configs.WorkParameters.ChartWorkParameters.yAxis)
                                        && configs.WorkParameters.ChartWorkParameters.yAxis.length > yAxisIndex
                                        && ('units' in configs.WorkParameters.ChartWorkParameters.yAxis[yAxisIndex])
                                        && configs.WorkParameters.ChartWorkParameters.yAxis[yAxisIndex].units
                                        && Array.isArray(configs.WorkParameters.ChartWorkParameters.yAxis[yAxisIndex].units)
                                        && configs.WorkParameters.ChartWorkParameters.yAxis[yAxisIndex].units.length > 0) {
                                        for (let u = 0; u < configs.WorkParameters.ChartWorkParameters.yAxis[yAxisIndex].units.length; u++) {
                                            unit += configs.WorkParameters.ChartWorkParameters.yAxis[yAxisIndex].units[u];
                                        }
                                    }
                                    formatFunction = yAxis[yAxisIndex].axisPointer.label.formatter;
                                    console.debug("ChartWork.vue - getValuesTooltip - yAxisIndex - formatFunction, unit", formatFunction, unit);
                                }
                            }
                        }
                    }
                    if (getZValue) {
                        let zAxisIndex = 0;
                        unit = '';
                        if (('WorkParameters' in configs) && configs.WorkParameters != undefined
                            && ('ChartWorkParameters' in configs.WorkParameters)
                            && configs.WorkParameters.ChartWorkParameters != undefined
                            && ('zAxis' in configs.WorkParameters.ChartWorkParameters)
                            && configs.WorkParameters.ChartWorkParameters.zAxis != undefined
                            && Array.isArray(configs.WorkParameters.ChartWorkParameters.zAxis)
                            && configs.WorkParameters.ChartWorkParameters.zAxis.length > zAxisIndex
                            && ('units' in configs.WorkParameters.ChartWorkParameters.zAxis[zAxisIndex])
                            && configs.WorkParameters.ChartWorkParameters.zAxis[zAxisIndex].units != undefined
                            && Array.isArray(configs.WorkParameters.ChartWorkParameters.zAxis[zAxisIndex].units)
                            && configs.WorkParameters.ChartWorkParameters.zAxis[zAxisIndex].units.length > 0) {
                            for (let u = 0; u < configs.WorkParameters.ChartWorkParameters.zAxis[zAxisIndex].units.length; u++) {
                                unit += configs.WorkParameters.ChartWorkParameters.zAxis[zAxisIndex].units[u];
                            }
                        }
                        // Troisième donnée
                        if (('WorkParameters' in configs) && configs.WorkParameters != undefined
                            && ('CommonWorkParameters' in configs.WorkParameters)
                            && configs.WorkParameters.CommonWorkParameters != undefined
                            && ('datas' in configs.WorkParameters.CommonWorkParameters)
                            && configs.WorkParameters.CommonWorkParameters.datas != undefined
                            && Array.isArray(configs.WorkParameters.CommonWorkParameters.datas)
                            && configs.WorkParameters.CommonWorkParameters.datas.length > 2
                            && ('decimal' in configs.WorkParameters.CommonWorkParameters.datas[2])
                            && configs.WorkParameters.CommonWorkParameters.datas[2].decimal != undefined) {
                            formatFunction = 'FrenchNumberFormatDigit' + configs.WorkParameters.CommonWorkParameters.datas[2].decimal;
                        }
                        console.debug("ChartWork.vue - getValuesTooltip - zAxisIndex - formatFunction, unit", formatFunction, unit);
                    }

                    let value = '-';
                    if (a.value[dimensionValue.name] != undefined) {
                        console.debug("ChartWork.vue - getValuesTooltip - a.value - formatFunction ", a.value, formatFunction, typeof formatFunction);
                        if (formatFunction == undefined) {
                            value = a.value[dimensionValue.name] + ' ' + unit;
                        } else if (typeof formatFunction == 'function') {
                            value = formatFunction(a.value[dimensionValue.name]) + ' ' + unit;
                        } else {
                            value = this.FunctionsList[formatFunction](a.value[dimensionValue.name]) + ' ' + unit;
                        }
                    }

                    values.push({
                        serieName: a.seriesName.split(' || '),
                        legend: (legendName != undefined ? legendName.split('\n') : [ a.seriesName ]),
                        marker: a.marker,
                        value: value
                    });
                }
            });
            console.debug("ChartWork.vue - getValuesTooltip - values", values);
            return values;
        }
    }

    //#endregion

    private median(arr) {
        const nums = [...arr].filter(a => a != undefined && a != null && !isNaN(a)).sort((a, b) => a - b);
        const mid = Math.floor(nums.length / 2);
        let value = arr.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2;
        console.debug('ChartWork.vue - median - nums, value', nums, value);
        return value;
    }

    /** Sur changement du type de graphique : mise à jour du context d'état pour obtenir l'implémentation dépendante du type de graphique */
    @Watch('configs.WorkParameters.ChartWorkParameters.graphType')
    private async changeState(newVal, oldVal) {
        console.debug("ChartWork - changeState (newVal : %O)", newVal);

        if (newVal) {
            /** Changement du type de graphique */
            this.initStateMachine<ChartState>("Chart", (state, results: any, configs: Dictionary<any>, variant: string) => {
                return new ChartContext(state as any, results, configs, variant);
            }, newVal);

            console.debug("ChartWork - changeState (this.context 2 : %O)", this.context);
        }
    }

    created() {
        if (this.results == undefined)
            this.results = {option: {}, graphTheme: "default-theme"};
    }

    /** Changement de la page */
    mounted() {
        // Création des différentes transformations possibles sur les données pour le graphique
        console.debug('ChartWork.vue - mounted');
        
        // Information de prise en compte des compteurs (utilisé sur cout unitaire pour le moment)
        let handleMeters = false;
        if(this.configs && 'Data' in this.configs && this.configs.Data && 'IsHandleByMeters' in this.configs.Data.at(0)) 
            handleMeters = this.configs.Data.at(0).IsHandleByMeters;

        console.debug("ChartWork - mounted - handleMeters : %O", handleMeters);

        // Ajout des transformations possibles dans les graphiques
        /** Changement des unités pour l'instant sans les informations de facteur */
        echarts.registerTransform({
            type: 'custom:unitchange',
            transform: function (params): ExternalDataTransformResultItem {
                console.debug('ChartWork.vue - custom:unitchange - params', params);
                let data: any = params.upstream.cloneRawData();
                map(data, function (a) {
                    console.debug('ChartWork.vue - custom:unitchange - a', a);
                    if (('config' in params) && params.config) {
                        a = getValueChart(a, params.config, 'obj', handleMeters);
                    }
                    console.debug('ChartWork.vue - custom:unitchange - a - fin', a);
                    return a;
                });
                return {
                    data: data
                };
            }
        });

        /** Cumul des données */
        echarts.registerTransform({
            type: 'custom:cumulative',
            transform: function (params): ExternalDataTransformResultItem {
                let data: any = params.upstream.cloneRawData();
                map(data, function (a, i) {
                    if (!(('initValue') in a))
                        a.initValue = a.value;
                    if (i > 0)
                        a.value = a.value + data[i - 1].value;
                    return a;
                });
                return {
                    data: data
                };
            }
        });

        /** Modification des valeurs en fonction des facteurs définies */
        echarts.registerTransform({
            type: 'custom:factorsCalcul',
            transform: function (params): ExternalDataTransformResultItem {
                console.debug('ChartWork.vue - custom:factorsCalcul - params', params);
                let data: any = params.upstream.cloneRawData();
                map(data, function (a) {
                    if (!(('initValue') in a))
                        a.initValue = a.value;
                    console.debug('ChartWork.vue - custom:factorsCalcul - a', a);
                    a = getValueChart(a, {
                        units: undefined,
                        works: undefined
                    });
                    return a;
                });
                return {
                    data: data
                };
            }
        });

        /** Ajout des thèmes possibles pour les graphiques */
        echarts.registerTheme(DefaultTheme.themeName, DefaultTheme.theme);
        echarts.registerTheme(LightOrangeTheme.themeName, LightOrangeTheme.theme);
        echarts.registerTheme(DarkOrangeTheme.themeName, DarkOrangeTheme.theme);
        echarts.registerTheme(LightPinkTheme.themeName, LightPinkTheme.theme);
        echarts.registerTheme(DarkPinkTheme.themeName, DarkPinkTheme.theme);
        echarts.registerTheme(LightPurpleTheme.themeName, LightPurpleTheme.theme);
        echarts.registerTheme(DarkPurpleTheme.themeName, DarkPurpleTheme.theme);
        echarts.registerTheme(LightMacaronsTheme.themeName, LightMacaronsTheme.theme);
        echarts.registerTheme(DarkMacaronsTheme.themeName, DarkMacaronsTheme.theme);
        echarts.registerTheme(LightAllColorsTheme.themeName, LightAllColorsTheme.theme);
        echarts.registerTheme(DarkAllColorsTheme.themeName, DarkAllColorsTheme.theme);
    }

    beforeDestroy() {
        let echartsTooltip = document.getElementsByClassName('echarts-tooltip');
        if (echartsTooltip != undefined && echartsTooltip.length > 0) {
            for (let i = echartsTooltip.length - 1; i >= 0; i--) {
                echartsTooltip[i].remove();
            }
        }
    }
}

let arrayProto = Array.prototype;
let nativeMap = arrayProto.map;

/**
 * Placement à l'endroit du click du menu et des sous-menus.
 * @param obj
 * @param cb
 */
function map(obj, cb) {
    if (!(obj && cb)) {
        return;
    }
    if (obj.map && obj.map === nativeMap) {
        return obj.map(cb);
    } else {
        let result = [];
        for (let i = 0, len = obj.length; i < len; i++) {
            result.push(cb.call(obj[i], i, obj));
        }
        return result;
    }
}

/**
 * Modification de la value en fonction des paramètres
 * @param a
 * @param params
 */
function getValueChart(a, config, returnType: string = 'obj', handleMeters : boolean = false) {
    console.debug('ChartWork.vue - getValueChart - a, config', a, config);
    let valueCalculate = undefined;
    let valueList = [];
    if (!('initValue' in a))
        a.initValue = {...a};

    for (let prop in a) {
        if (prop.includes('value'))
            valueList.push(prop);
    }

    if (valueList.length == 0)    {
        valueList.push('value');
    }
    console.debug('ChartWork.vue - getValueChart - valueList', valueList);

    for (let valIndex = 0; valIndex < valueList.length; valIndex++) {
        let valueName: string = valueList[valIndex];
        let valueTemp: string[] = valueName.split('value');
        let noValue: number = valueTemp.length > 1 ? (isNaN(parseInt(valueTemp[1])) ? 1 : parseInt(valueTemp[1])) : 1;

        let values = a[valueName];
        console.debug('ChartWork.vue - getValueChart - value, noValue', values, a.initValue, noValue);

        let dataId: number = 0;
        if (config && ('data' in config) && config.data)
            dataId = config.data;
        if (valueName === 'value1'){
            dataId = 0;
        }else if (valueName === 'value2'){
            dataId = 1;
        }else if (valueName === 'value3'){
            dataId = 2;
        }

        let valueResult = undefined;
        if (values != null) {
            if (('initValue' in a) && a.initValue != undefined) {
                if (typeof a.initValue == 'object' && !Array.isArray(a.initValue))
                    values = a.initValue[valueName];
                else
                    values = a.initValue;
            }
            if (!Array.isArray(values)) {
                let tempValues = [];
                tempValues.push(values);
                values = tempValues;
            }

            let valueList = [];
            console.debug('ChartWork.vue - getValueChart - values', a);
            
            // Variables de somme utilisés pour le calcul des ratio de coût unitaire prenant en compte les compteurs (case à cocher présente dans options avancées) 
            let sumValue = 0;
            let sumFactor = 0;
            
            for (let i = 0; i < values.length; i++) {
                let value = values[i];
                console.debug('ChartWork.vue - getValueChart - value, i, valueResult', value, i, valueResult);

                let coefficient = 1;
                let bddCoefficient = 1;
                console.debug('ChartWork.vue - getValueChart - config.works - all', dataId, config.works, config.works?.datas, config.works?.datas.length);
                if (config.works != undefined
                    && config.works?.datas && config.works?.datas.length > dataId
                    && config.works?.datas[dataId].units != undefined
                    && Array.isArray(config.works?.datas[dataId].units)
                    && config.works?.datas[dataId].units.length > 0) {
                    console.debug('ChartWork.vue - getValueChart - units', config.works?.datas[dataId].units);
                    let unitId = config.works?.datas[dataId].units[0];
                    console.debug('ChartWork.vue - getValueChart - unitId[0]', unitId);
                    let unit = config.units.find(o => o.id == unitId);
                    if (unit) {
                        coefficient = unit.coefficient;
                    }
                }
                if (config.works != undefined
                    && config.works?.datas && config.works?.datas.length > dataId
                    && config.works?.datas[dataId].bddUnits != undefined
                    && Array.isArray(config.works?.datas[dataId].bddUnits)
                    && config.works?.datas[dataId].bddUnits.length > 0) {
                    console.debug('ChartWork.vue - getValueChart - units', config.works?.datas[dataId].units);
                    let unitId = config.works?.datas[dataId].bddUnits[0];
                    console.debug('ChartWork.vue - getValueChart - unitId[0]', unitId);
                    let unit = config.units.find(o => o.id == unitId);
                    if (unit) {
                        bddCoefficient = unit.coefficient;
                    }
                }
                console.debug('ChartWork.vue - getValueChart - All', value, a.initValue, typeof value, typeof a.initValue, noValue, coefficient, bddCoefficient, valueName);
                value = value * (coefficient ?? 1) / (bddCoefficient ?? 1);
                console.debug('ChartWork.vue - getValueChart - value, coefficient, BDDcoefficient, dataId', value, coefficient, bddCoefficient, dataId);
                
                // Cumul des données des numérateurs (pour cout unitaire)
                sumValue += value;
                
                if (('factors' in a) && a.factors) {
                    let factors = a.factors;
                    if (!Array.isArray(a.factors)) {
                        factors = [a.factors];
                    }

                    factors = factors.filter(a => ('dataId' in a) ? a.dataId == noValue : 1);
                    console.debug('ChartWork.vue - getValueChart - factors', factors);
                    if (factors != undefined) {
                        for (let j = 0; j < factors.length; j++) {
                            let factor = factors[j];
                            let factorValue = undefined;
                            if (!Array.isArray(factor.value)) {
                                factorValue = factor.value;
                            } else {
                                factorValue = factor.value[i];
                            }

                            // Cumul des données des dénominateurs (pour cout unitaire)
                            sumFactor += factorValue;

                            console.debug('ChartWork.vue - getValueChart - factorValue, i, valueResult', factorValue, i, valueResult);
                            let coefficientFactor = 1;
                            let bddCoefficientFactor = 1;
                            if (config.works?.datas && config.works?.datas.length > dataId
                                && config.works?.datas[dataId].units
                                && config.works?.datas[dataId].units.length > j * 2 + 2) {
                                console.debug('ChartWork.vue - getValueChart - config.works?.datas[dataId].units[j * 2 + 2]', config.works?.datas[dataId].units, j * 2 + 2);
                                let unitFactorId = config.works?.datas[dataId].units[j * 2 + 2];
                                let unitFactor = config.units.find(o => o.id == unitFactorId);
                                if (unitFactor) {
                                    coefficientFactor = unitFactor.coefficient;
                                }
                            }
                            if (config.works?.datas && config.works?.datas.length > dataId
                                && config.works?.datas[dataId].bddUnits
                                && config.works?.datas[dataId].bddUnits.length > j * 2 + 2) {
                                console.debug('ChartWork.vue - getValueChart - config.works?.datas[dataId].bddUnits[j * 2 + 2]', config.works?.datas[dataId].bddUnits, j * 2 + 2);
                                let unitFactorId = config.works?.datas[dataId].bddUnits[j * 2 + 2];
                                let unitFactor = config.units.find(o => o.id == unitFactorId);
                                if (unitFactor) {
                                    bddCoefficientFactor = unitFactor.coefficient;
                                }
                            }
                            if (factorValue != undefined && factorValue != null) {
                                factorValue = factorValue * (coefficientFactor ?? 1) / (bddCoefficientFactor ?? 1);

                                console.debug('ChartWork.vue - getValueChart - factorValue, coefficientFactor', factorValue, coefficientFactor);
                                switch (factor.operator) {
                                    case '*':
                                        value = value * factorValue;
                                        break;
                                    case '/':
                                        value = value / factorValue;
                                        break;
                                }
                            } else
                                value = undefined;
                        }
                    }
                }
                valueList.push(value);
                console.debug('ChartWork.vue - getValueChart - value', value)
            }

            valueList = valueList.filter( a=> a != undefined);
            if (valueList.length >0) {
                valueResult = 0;
                for (let a = 0; a < valueList.length; a++) {
                    valueResult += valueList[a];
                }

                // Si prise en compte des compteurs => on fait la somme des cout sur la somme des consommations (cout unitaire) 
                if(handleMeters)
                    valueResult = sumValue / sumFactor;
                else
                    valueResult = valueResult / valueList.length;
            }
            console.debug('ChartWork.vue - getValueChart - valueList, valueResult', valueList, valueResult);   
        }
        valueCalculate = isNaN(valueResult) ? undefined : valueResult;
        a[valueName] = valueCalculate;
        console.debug('ChartWork.vue - getValueChart - ValueSet', a, valueCalculate);
    }

    if (returnType == 'obj')
        return a;
    else
        return valueCalculate;
}


</script>

<style scoped>
:deep(.echarts-tooltip) {
    opacity: 0.9 !important;
}

:deep(path[d="M-3.2012 -2.3994C-2.6676 -2.3994 -2.4024 -2.1341 -2.4024 -1.6006L-2.4024 1.6006C-2.4024 2.1341 -2.6676 2.3994 -3.2012 2.3994C-3.7347 2.3994 -4 2.1341 -4 1.6006L-4 -1.6006C-4 -2.1341 -3.7347 -2.3994 -3.2012 -2.3994ZM0 -2.3994C0.5335 -2.3994 0.7988 -2.1341 0.7988 -1.6006L0.7988 1.6006C0.7988 2.1341 0.5335 2.3994 0 2.3994C-0.5335 2.3994 -0.7988 2.1341 -0.7988 1.6006L-0.7988 -1.6006C-0.7988 -2.1341 -0.5335 -2.3994 0 -2.3994ZM3.2012 -2.3994C3.7347 -2.3994 4 -2.1341 4 -1.6006L4 1.6006C4 2.1341 3.7347 2.3994 3.2012 2.3994C2.6676 2.3994 2.4024 2.1341 2.4024 1.6006L2.4024 -1.6006C2.3994 -2.1341 2.6676 -2.3994 3.2012 -2.3994Z"]) {
    fill: var(--Variant) !important;
}

:deep(.vue-echarts-inner){
    height: 100% !important;
}

:deep(td.eventDescription) {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 1px;
}
</style>